import React from "react";

const Java_GCD = () => {
  return (
    <div>
      <h1>Java GCD</h1>
      <p>This page provides explanations, examples, and common use-cases for Java GCD in Java.</p>
    </div>
  );
};

export default Java_GCD;
